import { LiveAgentQueue } from './types';

export type CopilotToggleCustomEventDetail = {
  eventType: 'message' | 'action',
  eventSource?: string,
  eventData: {
    ActionId?: 'liveAgentSupport',
    endDate?: string,
    FlowId?: string,
    isHidden?: boolean,
    message?: string,
    pluginName?: string,
    startDate?: string,
    liveAgentParameters?: {
      problemDescription?: string,
      queue?: LiveAgentQueue,
    },
  },
};

export class CopilotToggleCustomEvent extends CustomEvent<CopilotToggleCustomEventDetail> {
  constructor(eventInit: CustomEventInit<CopilotToggleCustomEventDetail>) {
    super(CopilotToggleCustomEvent.copilotToggleCustomEventName, eventInit);
  }

  static copilotToggleCustomEventName = 'copilotToggleEvent';
}
